import React from 'react'
import { Link } from 'gatsby'
import styled from 'styled-components'
import { Helmet } from 'react-helmet'
import PageTitle from '../components/PageTitle'
import Container from '../components/Container'
import Layout from '../components/Layout'
import config from '../utils/siteConfig'

const Text = styled.p`
  text-align: center;
  line-height: 1.6;
  a {
    color: #121212;
  }
`

const NotFoundPage = () => (
  <Layout>
    <Helmet>
      <title lang={config.language}>404 - Página não encontrada</title>
      <meta
        name="description"
        content="Página não encontrada - Cashback Ranking"
      />
    </Helmet>

    <Container>
      <PageTitle>Página não encontrada</PageTitle>
      <Text>
        Por favor, retorne para <Link to="/">home</Link> ou use o menu para
        navigar para uma página diferente.
      </Text>
    </Container>
  </Layout>
)

export default NotFoundPage
